import apiFetch from '../apiFetch'

export default function (token, dossierSubTypeId, includeDeleted = false) {
  return apiFetch({ endPoint: `Reason?dossierSubtypeId=${dossierSubTypeId}&includeDeleted=${includeDeleted}`, method: 'GET', body: null, token: token })
}
